module.exports = __webpack_public_path__ + "static/media/sushi-logo.effd39c6.png";